export default {
    'protokol/storefront': () => import('@/components/integrations/protokol/storefront/events.js'),
    'protokol/media': () => import('@/components/integrations/protokol/media/events.js'),
    'protokol/invoicing': () => import('@/components/integrations/protokol/invoicing/events.js'),
    'protokol/vpfr': () => import('@/components/integrations/protokol/vpfr/events.js'),
    'protokol/ocr': () => import('@/components/integrations/protokol/ocr/events.js'),
    'protokol/clerk': () => import('@/components/integrations/protokol/clerk/events.js'),
    'protokol/payments': () => import('@/components/integrations/protokol/payments/events.js'),
    'protokol/deliveries': () => import('@/components/integrations/protokol/deliveries/events.js'),
    'protokol/minimax': () => import('@/components/integrations/protokol/minimax/events.js'),
    'protokol/monri': () => import('@/components/integrations/protokol/monri/events.js'),
    'protokol/aikbank': () => import('@/components/integrations/protokol/aikbank/events.js'),
    'protokol/ecommerce': () => import('@/components/integrations/protokol/ecommerce/events.js'),
    'protokol/mail': () => import('@/components/integrations/protokol/mail/events.js'),
    'protokol/inbox': () => import('@/components/integrations/protokol/inbox/events.js'),
    'protokol/support': () => import('@/components/integrations/protokol/support/events.js'),
    'protokol/timber': () => import('@/components/integrations/protokol/timber/events.js'),
}
